import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarEmbedRoute: InvariantJiraRoute = {
	name: 'software-calendar-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
	query: ['date?'],
};
